import React, { memo } from 'react';
import { Link } from 'react-router-dom';
export const AboutPage = () => {
  return <div className="w-full bg-gradient-to-r from-primary-50 via-white to-primary-50" data-id="element-489">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-490">
        <div className="text-center mb-12" data-id="element-491">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800" data-id="element-492">
            About Toddler Time
          </h1>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-493">
            Creating magical play experiences for little ones across Atlanta
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-494">
          <div data-id="element-495">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cjmN3zEpJAdAE8AFogpUQU/image.png" alt="White castle bounce house with slide and balloon arch in outdoor setting" className="w-full h-auto rounded-lg shadow-xl" data-id="element-496" />
          </div>
          <div className="text-left" data-id="element-497">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-498">
              A Passion for Playtime
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-499">
              Toddler Time specializes in premium soft play rentals, creating
              joyful and safe environments. We've transformed countless events,
              ensuring memorable experiences for toddlers and peace of mind for
              parents in the Metro Atlanta area.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-500">
              Our mission is to create magical moments through play, helping
              children develop essential skills while having the time of their
              lives. Every piece of equipment we offer is carefully selected for
              safety, engagement, and pure joy.
            </p>
            <Link to="/cart" className="inline-flex items-center px-6 py-3 bg-secondary-500 text-white rounded-md font-medium shadow-lg hover:bg-secondary-600 transition-all" onClick={() => window.scrollTo(0, 0)} data-id="element-501">
              Book Now
            </Link>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-lg p-8 border border-gray-100 mb-16" data-id="element-502">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-503">
            Our Story
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-504">
            <p className="text-lg text-gray-600 mb-6" data-id="element-505">
              Toddler Time was created from a simple idea: toddlers deserve
              safe, fun, and exciting spaces to play — and parents deserve to
              enjoy the celebration too. As parents ourselves, we saw a need for
              high-quality, mobile play experiences that could be brought
              straight to homes, parks, and event spaces without breaking the
              bank.
            </p>
            <p className="text-lg text-gray-600 mb-6" data-id="element-506">
              Our mission is to create magical, stress-free, and memorable
              moments for little ones and their families. We deliver clean,
              thoughtfully designed soft play setups that spark imagination,
              encourage movement, and bring joy to every toddler-friendly event.
            </p>
            <p className="text-lg text-gray-600" data-id="element-507">
              At Toddler Time, we're all about helping families make
              unforgettable memories. Whether it's a birthday party, family
              reunion, or community event, we're here to bring the fun — and
              take the stress off your plate.
              <br data-id="element-508" />
              <br data-id="element-509" />
              Let us bring the magic to your next event. Book today and let the
              good times roll!
            </p>
          </div>
        </div>
        <div className="text-center" data-id="element-510">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-511">
            Ready to Create Magical Memories?
          </h2>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-512">
            <Link to="/cart" className="inline-flex items-center px-8 py-4 bg-secondary-500 text-white rounded-md font-bold text-lg shadow-lg hover:bg-secondary-600 transition-all" onClick={() => window.scrollTo(0, 0)} data-id="element-513">
              Book Now
            </Link>
            <Link to="/#services" className="inline-flex items-center px-8 py-4 bg-primary-500 text-white border border-primary-500 rounded-md font-bold text-lg hover:bg-primary-600 transition-all" data-id="element-514">
              Explore Our Services
            </Link>
          </div>
        </div>
      </div>
    </div>;
};